import React from 'react'
import Container from '../../components/common/container/Container'
import { CREATE_MSG, INSTALLER_INFO_MSG, INSTALLER_MSG } from '../../utils/constants/GlobalConstants'
import CreateDebiForm from '../../components/createDebi/CreateDebiForm'
import { DEBI_CREATE } from '../../utils/routes/Routes'
import { AppH5Header, AppH6Header } from '../../components/common/appHeaders/AppHeaders';

const CreateDebi = () => {
  return (
    <Container breadCrumb={true} activeBreadCrumbLink={DEBI_CREATE} title={CREATE_MSG}>
        <AppH5Header text={INSTALLER_MSG} />
        <AppH6Header text={INSTALLER_INFO_MSG}/>
      <CreateDebiForm />
    </Container>
  )
}

export default CreateDebi